import React, { useContext } from 'react';
import { ScrollSyncPane } from './ScrollSync';
import TableContext from './TableContext';

export default function TableTBody({
  children,
}: {
  children: React.ReactNode;
}) {
  const {
    table: { getTableBodyProps },
  } = useContext(TableContext);

  return (
    <ScrollSyncPane>
      <div {...getTableBodyProps()} className="tbody">
        <div className="tbody-inner">{children}</div>
      </div>
    </ScrollSyncPane>
  );
}
